<template>
	<div :class="classNames+ '_subwrap'">
		<div :class="classNames+ '_main'">
			<div :class="classNames+ '_sidebar'">
				<div :class="classNames+ '_group'">
					<a type="primary" @click.prevent.stop="addGroup"><i class="el-icon-circle-plus-outline compile-icon"></i>新增分组</a>
				</div> 
				<ul :class="classNames+ '_grouplist'">
					<li :class="groupIndex == 0 ? 'active': '' " @click.prevent.stop="getSelectReply(false)">
						<p class="gruop_title">全部分组</p>
					</li>
					<li v-for="(item,index) of groupListData" :class="groupIndex == (index+1) ? 'active': '' " @click.prevent.stop="getSelectReply(true,item,index)">
						<p class="gruop_title">{{item.name}}</p>
						<p class="group_icon">
							<i class="el-icon-delete compile-icon" @click.prevent.stop="deleteGroupModal(item)"></i>
							<i class="el-icon-edit-outline compile-icon" @click.prevent.stop="editGroupModal(item)"></i>
						</p>
					</li>
				</ul>
			</div>
			<div :class="classNames+ '_content'">
				<useTable :searchForm="searchForm" :httprequest="httprequest" ref="useTable" :headerList="headerData" :showEmptyTable="false"></useTable>
			</div>
		</div>
		<!-- 话术卡片弹出 -->
		<replyDialog v-model="showReplyDialog" :replyFormInfo="replyFormInfo" :groupListData="groupListData" @replyList="getReplyList"></replyDialog>
		<!-- 分组卡片弹出 -->
		<groupDialog v-model="showGroupDialog" :groupInfo="groupInfo" @groupList="getGroupList()"></groupDialog>
	</div>
</template>
<script>
	
import useTable from '@/components/useTable/useTable.vue'
import { mapActions } from 'vuex'
import replyDialog from './fastReplyDialog.vue'
import groupDialog from './groupDialog.vue'
export default {
	props: {
		tabIndex: {
		    type: Number,
		    default: 1
		}
	},
	data() {
		const statusList = [
			{
				label: '全部',
				value: ''
			},
			
			{
				label: '审核中',
				value: 1
			},
			{
				label: '审核驳回',
				value: 2
			},
			{
				label: '审核通过',
				value: 3
			},
		]
		return {
			classNames: 'fastList',
			showReplyDialog: false,
			showGroupDialog: false,
			groupIndex: 0,
			groupListData: [],
			searchForm: [
				{
					defaultValue: '',
					label: '话术内容:',
				    Component: 'el-input',
					prop: 'title',
					span: 8,
				    componentProps: {
				        placeholder: '请输入标题/话术内容'
				    }
				},
				{
					Component: 'el-button',
					span: 4,
				    componentProps: {
				       type: "primary"
				    },
				    renderHTML: () => {
				        return '查询'
				    },
				    on: {
				        click: this.getReplyList
				    }
				},
				{
					Component: 'el-button',
					span: 4,
				    componentProps: {
				       type: "primary"
				    },
				    renderHTML: () => {
				        return '+创建话术'
				    },
				    on: {
				        click: this.addReplyModal
				    }
				},
			],
			headerData: [
				{
					props: {
                        prop: 'content',
                        label: '内容'
                    },
					render:(h, scope)=> {
						if(scope.row.type == 2){
							return (
								<div>
								{scope.row.content} <span class={this.classNames+'_operation_title'} onClick={this.replyLinkFun.bind(this,scope.row)}>{scope.row.link_title}</span> 
								</div>
							)
						} else {
							return (
								<div>
									{scope.row.content}
								</div>
							)
						}
					}
				},
				{
					props: {
				        prop: 'title',
				        label: '标题',
				        width: 150
				    }
				},
				{
					props: {
                        prop: 'type_desc',
                        label: '类型',
						width: 120
                    }
				},
				{
					props: {
				        prop: 'send_count',
				        label: '总发送次数',
				        width: 120
				    }
				},
                {
                    props: {
                        label: '操作',
                        width: 220
                    },
                    render:(h, scope)=> {
                        return (
							<div>
								<span class={this.classNames+'_operation_title'} onClick={this.replyEditModal.bind(this,scope.row)}>编辑</span>
								<span class={this.classNames+'_operation_title'} onClick={this.replyShowHideFun.bind(this,scope.row)}>{this.formatShowText(scope.row)}</span>
								<span class={this.classNames+'_operation_title'} onClick={this.replyDeleteFun.bind(this,scope.row)}>删除</span>
								{scope.row.sort == 0 ? <span class={this.classNames+'_operation_disable'} >置顶</span> : <span class={this.classNames+'_operation_title'} onClick={this.replyTopFun.bind(this,scope.row)}>置顶</span>}
								
							</div>
						)
                    }
                }
			],
			searchFormObj: {
				group_id: ''
			},
			groupInfo:{},
			replyFormInfo:{},
		}
	},
	components: {
		useTable,
		replyDialog,
		groupDialog
	},
	created() {
		this.getGroupList()
	},
	methods: {
		...mapActions('dymessage', ['replyList','replyTop','replyDel','replyShowHide','groupList','groupDel']),
		addGroup() {
			this.showGroupDialog = true
		},
		editGroupModal(data) {
			this.groupInfo = Object.assign({},data)
			this.showGroupDialog = true
		},
		async getGroupList() {
			let res = await this.groupList()
			this.groupListData = res.data
		},
		getSelectReply(status,data,index){
			if(status){
				this.groupIndex = index+1
				this.searchFormObj.group_id = data.id
			} else {
				this.groupIndex = 0
				this.searchFormObj.group_id = ''
			}
			this.getReplyList()
		},
		getReplyList(status = true) {
			if(status){
				this.$refs.useTable.getRequestRes('firstPage')
			} else {
				this.$refs.useTable.getRequestRes()
			}
		},
		addReplyModal() {
			this.showReplyDialog = true
			this.replyFormInfo = Object.assign({},{
				id: '',
			    group_id: 0,
				title: '',
				type: 1,
				content: '',
				link_title: '',
				link_url: ''
			})
		},
		async deleteGroupModal(data) {
			this.$confirm(`确定要删除分组吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(async () => {
                    await this.groupDel({id:data.id})
					await this.getGroupList()
					this.$refs.useTable.getRequestRes("firstPage")
                    this.$message({
                        type: 'success',
                        message:'删除成功',
                        duration: 3000
                    })
                })
		},
		async replyTopFun(data){
			await this.replyTop({id:data.id})
			await this.getReplyList()
		},
		replyLinkFun(data){
			window.open(data.link_url)
		},
		replyEditModal(data){
			this.replyFormInfo = Object.assign({},data)
			this.showReplyDialog = true
		},
		async replyDeleteFun(data){
			const reply_type = this.tabIndex
			this.$confirm(`确定要删除吗?`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			    }).then(async () => {
			        await this.replyDel({id:data.id,reply_type: reply_type})
			        await this.getReplyList()
			        this.$message({
			            type: 'success',
			            message:'删除成功',
			            duration: 3000
			        })
			    })
				
			
		},
		async replyShowHideFun(data){
			console.log('data',data)
			let is_show = ''
			if(data.is_show == 1) {
				is_show = 2
			} else if(data.is_show == 2) {
				is_show = 1
			} else {
				is_show == 2
			}
			await this.replyShowHide({id:data.id, is_show: is_show,reply_type: this.tabIndex})
			await this.getReplyList(false)
		},
		formatShowText(data){
			if(data.is_show == 1){
				return '隐藏'
			} else if(data.is_show == 2){
				return '显示'
			} else {
				return ''
			}
		},
		async httprequest(params) {
			params.limit = params.pageSize
			params.group_id = this.searchFormObj.group_id
			let res = await this.replyList(params)
			return {total: res.count,data: res.list}
		}
	}
}
</script>
<style lang="less" scoped>
	 @classNames: fastList;
	 .@{classNames}_main{
		display: flex;
		flex: 1;
	 }
	 .groupItemClass{
	 	display: flex;
	 	align-items: center;
	 	justify-content: space-between;	
	 	width: 100%;
	 	height: 48px;
	 	border-bottom: 1px solid #EBEEF5;
	 	padding: 12px 0 12px 10px;
	 	box-sizing: border-box;
	 	text-align: left;
	 	font-size: 14px;
	 	color: #606266;
	 }
	 .@{classNames}_sidebar{
	 	width: 200px;
		background-color:#fff;
		border: 1px solid #d7d7d7;
		min-height: 100%;
		box-sizing: border-box;
		margin-right: 10px;
		.@{classNames}_group{
			&:extend(.groupItemClass);
			text-align: center;
			justify-content: center;
			align-items: center;
			a{
				color: #1989FA;
				font-size: 14px;
			}
			.compile-icon{
				margin-right: 4px;
				font-size: 20px;
			}
		}
		.@{classNames}_grouplist{
			height: 600px;
			overflow: auto;
			li{
				cursor: pointer;
				&:extend(.groupItemClass);
				&:hover{
				 background: #f5f7fa;
				 .group_icon{
				 	display: block;
				 }
				}
				&.active{
					background-color: #409eff!important;
					color: #FFFFFF!important;
					.group_icon{
						display: block;
					}
				}
				.gruop_title{
					width: 120px;
					overflow: hidden;
					text-overflow: ellipsis; 
					-o-text-overflow: ellipsis;
					white-space:nowrap;
				}
				.group_icon{
					display: none;
				}
				.compile-icon{
				  float: right;
				  margin-right: 10px;
				  cursor: pointer;
				}
			}
		}
	 }
	 .@{classNames}_content{
		 display: flex;
		 flex-direction: column;
		 flex: 1;
	 }
</style>
<style lang="less">
	@classNames: fastList;
	.@{classNames}_operation_title,.@{classNames}_operation_disable {
			margin-right: 12px;
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
	}
	.@{classNames}_operation_disable{
		color: #bababa;
	}
</style>
